import React from 'react';
import PropTypes from 'prop-types';
import styles from './uploadInteraction.scss';
import a11yIIBScreenReaderService from '../../../../services/a11yIIBScreenReaderService';

class RemoveButton extends React.PureComponent {
    static propTypes = {
        disabled: PropTypes.bool,
        services: PropTypes.object.isRequired,
        showConfirmation: PropTypes.func.isRequired,
    };

    render() {
        const { t } = this.props.services.translationService;
        const ariaLabelValueforRemoveButton = a11yIIBScreenReaderService.getAriaLabelValue(
            undefined,
            t('interactions.upload.a11yBtnRemove'),
        );

        return (
            <button
                className={styles.button}
                disabled={this.props.disabled}
                onClick={this.props.showConfirmation}
                aria-label={ariaLabelValueforRemoveButton}
            >
                <i className="fa fa-times" aria-hidden="true" />{t('interactions.upload.btnRemove')}
            </button>
        );
    }
}

export default RemoveButton;
